module.exports = __webpack_public_path__ + "img/web-formularios-03.418fff71.svg";